import { cca_config } from '@/config';

export default {
    name: 'format-ticket',
    components: {},
    props: {
        selected_facture: Object,
        patient_insurance_info: Object,
        total_net: Number,
        montant_en_lettre: String
    },
    data() {
        return {
            nom_clinique: ''
        }
    },

    computed: {

    },

    mounted() {
        this.nom_clinique = cca_config.NOM_CLINIQUE
    },

    methods: {

    }
}